import { Drawer } from '@/components/modal/Drawer'
import { useMarkNotificationAsRead, useNotifications } from './hooks/notifications'
import { Title } from '@/components/commons/typography/Title'
import { ButtonComponent } from '@/components/commons'
import { CloseIcon } from '@/public/assets/v2/images/icons'
import { NotificationItem } from './components/NotificationItem'
import { useContext, useEffect, useState } from 'react'
import { BrowserContext } from 'context'
import { ModalRequestConnection } from 'containers/profile/components/buttons/ModalRequestConnection'
import { User } from 'containers/user/types/user'
import { useRequestConnection } from 'containers/profile-network/hooks/useConnectionsActions'
import { useRouter } from 'next/router'

interface NotificationsProps {
  isOpen: boolean
  onClose: () => void
}

export const Notifications = ({ isOpen, onClose }: NotificationsProps) => {
  const { data, newNotifications } = useNotifications()
  const { isMobile } = useContext(BrowserContext)
  const { mutateAsync } = useMarkNotificationAsRead()

  const [showRequestConnectionModal, setShowRequestConnectionModal] = useState(false)
  const [userToConnect, setUserToConnect] = useState<User>()
  const { mutateAsync: requestConnection, isLoading: isRequesting } = useRequestConnection()

  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState(router.asPath);

  useEffect(() => {
    const handleRouteChange = (url) => {
      if (url !== currentUrl) {
        onClose()
        setCurrentUrl(url)
      }
    }

    router.events.on('routeChangeStart', handleRouteChange)

    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    };
  }, [currentUrl, onClose, router.events])

  useEffect(() => {
    const markAsRead = async () => {
      const newNotifications = data?.filter((notification) => !notification.read)
      if (newNotifications?.length) {
        const ids = newNotifications.map((notification) => notification.id)
        await mutateAsync(ids)
      }
    }

    if (isOpen) {
      markAsRead()
    }
  }, [isOpen, data, newNotifications, mutateAsync])

  const handleRequestConnection = async (message: string) => {
    await requestConnection({
      profile: userToConnect,
      message,
    })
    setShowRequestConnectionModal(false)
  }

  return (
    <>
      <ModalRequestConnection
        onClose={() => setShowRequestConnectionModal(false)}
        isOpen={showRequestConnectionModal}
        profileId={userToConnect?.id}
        onRequestConnection={handleRequestConnection}
        disabled={isRequesting}
      />

      <Drawer
        className="--v2"
        position="left"
        opened={isOpen && !showRequestConnectionModal}
        onClose={onClose}
        withCloseButton={false}
        style={{
          zIndex: 11000002,
          position: 'relative',
        }}
        styles={!isMobile && {
          content: {
            maxWidth: 554,
            width: '100%',
            flex: `0 0 100%`,
          }
        }}
      >
        <div className="py-20">
          <div className="flex justify-space-between items-center">
            <Title variation="small" sizeClass="text-18">
              Notifications
            </Title>
            <ButtonComponent
              onlyIcon
              iconLeft={<CloseIcon className="text-priamry" />}
              size="xSmall"
              // className="text-primary"
              variation="white-bg"
              onClick={onClose}
            />
          </div>

          <div className="py-20 full-w flex flex-column gap-10">
            {data?.map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                onRequestConnection={(profile) => {
                  setUserToConnect(profile)
                  onClose()
                  setShowRequestConnectionModal(true)
                }}
              />
            ))}
          </div>
        </div>
      </Drawer>
    </>
  )
}
